module.exports = __webpack_public_path__ + "img/ic-shipment-outgoing.76074d3f.svg";